var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showGoHome)?_c('div',{staticClass:"gohome-container"},[_c('img',{attrs:{"src":require("@/assets/go_home.png")},on:{"click":_vm.goHome}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }